// extracted by mini-css-extract-plugin
export var closeButton = "_1p-3";
export var header = "_1p-0";
export var link = "_1p-1";
export var retryButton = "_1p-2";